
/**
 * Tipo de seleção de datas. Usado para determinar o tratamento da seleção das datas.
 */
export enum RainCalendarSelectionType {

  /** Selecionar apenas uma data. */
  SINGLE,

  /** Selecionar duas datas. */
  INTERVAL,
}
  